import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loansDetailCollapseComponent from './loansDetailCollapse.component';

let loansDetailCollapseModule = angular.module('loansDetailCollapse', [
  uiRouter
])

.component('loansDetailCollapse', loansDetailCollapseComponent)

.name;

export default loansDetailCollapseModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailCollapse/loansDetailCollapse.js